<template>
  <Button
    fsize="f12"
    variant="download_gy"
    radius
    class="l-w-155"
    :class="{ 'is-loading': isProcessing }"
    :disabled="isProcessing"
    @click="download"
  >
    <Icon2 variant="download" :size="12" />
    <span>CSVダウンロード</span>
  </Button>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import utils from '@/utils';
import iconv from 'iconv-lite';

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  components: {
    Button,
    Icon2
  },
  data() {
    return {
      isProcessing: false
    };
  },
  methods: {
    download() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      // 月間検索数の降順で並び替える
      const sortedItems = utils.sort(
        this.items.slice(),
        'number',
        'desc',
        'searchVolume'
      );

      const header = `キーワード,調査月,月間検索数`;
      const rows = sortedItems
        .map(item => {
          let yearMonth = item.yearMonth;
          let searchVolume = item.searchVolume;
          if (yearMonth === null) {
            yearMonth = '';
          } else {
            yearMonth = utils.formatDate(yearMonth, 'YYYY年M月');
          }
          if (searchVolume === null) {
            searchVolume = '';
          }
          return `${item.keyword},"${yearMonth}",${searchVolume}`;
        })
        .join('\n');
      const data = iconv.encode(`${header}\n${rows}`, 'Shift_JIS');

      const now = utils.formatDate(new Date(), 'YYYY年MM月DD日');
      const fileName = `検索ボリューム調査_${now}.csv`;
      utils.downloadFile(data, fileName);

      this.isProcessing = false;
    }
  }
};
</script>
